module.exports = __webpack_public_path__ + "img/logo1.665e1c7d.png";